<template>
  <section class="panel">
    <div class="fading">
      <h1>Thank you</h1>
      <div class="text" v-html="text.thank_you" v-if="text"></div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    text() {
      return this.$store.state.text
    }
  }
}
</script>

<style scoped>
.text {
  max-width: 125rem;
  margin: auto;
}

.panel {
  text-align: center;
}
</style>
